import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

// css
import 'assets/style/elements/label.scss'

function Label({
  text,
  smallText,
  className = '',
  type = 'default',
  size = 'medium',
  htmlFor = '',
  required = false,
  level = '1',
}) {
  if ([true, 'true'].includes(required)) className += ' required'
  if ([3, '3'].includes(level)) className += ' depth-3'
  return (
    <>
      <label htmlFor={htmlFor} className={'input-label ' + className}>
        {text}
        {smallText && <span>&nbsp;({smallText})</span>}
      </label>
    </>
  )
}

export default Label
